import {LoadingPlaceholder} from "@communicare/medications/Components/Placeholder";
import { Button, makeStyles } from '@material-ui/core';
import { Alert } from "@material-ui/lab";
import classes from "../../../common/alert/alert.module.scss";
import { ReactComponent as IconError } from "../../../../images/icon-error.svg";

export interface IExpandRowLoaderProps{
    inProgress: boolean;
    error: any;
    onRetryClicked: () => void,
     children: JSX.Element
}

const useStyles = makeStyles({
    title:{
        fontSize:"14px",
        fontWeight:"bold"
    },
    dateText:{
        fontSize:"12px",
        fontWeight:"bold"  
    },
    
})

export const ExpandRowLoader = (props: IExpandRowLoaderProps) => {
    if (props.inProgress) {
        return <LoadingPlaceholder/>
    }
    if (props.error) {
        return <ErrorPlaceHolder onRetryClicked = {() => {props.onRetryClicked()}}></ErrorPlaceHolder>
    }
    return <>{props.children}</>;
}

const ErrorPlaceHolder = (props: {onRetryClicked: () => void}) => {
    let errorClasses = useStyles();

  return (
    <Alert
        className={classes.errorAlert}
        icon={<IconError   className={classes.errorIcon}/>}
        variant="outlined"
        action={
            <Button
                color="primary"
                variant="contained"
                disableElevation={true}
                onClick={() => {
                    props.onRetryClicked();
                }}>
                Retry
         </Button>
        }>
        <div className={errorClasses.title}> Error loading medication details</div>
        Please try again.
   </Alert>
   )}